import { ScoopText, ScoopColumn } from '../../../../ui'
import styles from './WorkspaceBox.module.scss'

export const WorkspaceBox = ({ icon, title, subtitle, onClick, selected, className }) => {
    return (
        <ScoopColumn
            onClick={onClick}
            className={`${styles.workspaceBox} ${selected ? styles.selected : ''} ${className || ''}`}
        >
            {icon}
            <ScoopText className={styles.title}>{title}</ScoopText>
            <ScoopText className={styles.subtitle}>{subtitle}</ScoopText>
        </ScoopColumn>
    )
}
